Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokMessageContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.TikTokMessageContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.sub_type == 'tiktok-dm'
